export class SystemOptions{
    buttonLabel: string;
;}